import React from "react";
import { Paper, Box, Typography } from "@mui/material";

export default function NewsSidebar({ 
  list, 
  activeItem, 
  onNavigate,
  sx = {} 
}) {

  // Custom scrollbar style
  const scrollbarStyle = {
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-thumb": { backgroundColor: "#ccc", borderRadius: "3px" },
    "&::-webkit-scrollbar-track": { background: "transparent" },
  };

  return (
    <Paper
      elevation={4}
      sx={{
        p: 3, 
        backgroundColor: "#fff",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        height: "fit-content",
        maxHeight: 600,
        overflowY: "auto",
        ...scrollbarStyle,
        ...sx 
      }}
    >
      <Typography
        sx={{ fontWeight: 800, mb: 2, color: "#0a1a3b", fontSize: 18 }}
      >
        Post Archives 
      </Typography>

      {list && list.length > 0 ? (
        list.map((item, index) => {
          // Check if this item is the one currently displayed
          const isCurrent = activeItem && (
            (item.id && item.id === activeItem.id) || 
            (item.cardTitle === activeItem.cardTitle)
          );

          return (
            <Box key={index} sx={{ mb: 1 }}>
              {isCurrent ? (
                <Box sx={{ 
                    display: 'block', 
                    cursor: 'default', 
                    backgroundColor: "#f0f8ff", 
                    borderLeft: "4px solid #00b5e2", 
                    borderRadius: 1, 
                    p: 1 
                }}>
                  <Typography sx={{ fontWeight: 700, color: "#0a1a3b", fontSize: 13.5 }}> 
                    {item.cardTitle}
                  </Typography>
                </Box>
              ) : (
                // CLICKABLE ITEM
                <Typography
                  sx={{
                    fontSize: 13.5,
                    fontWeight: 700,
                    p: 1,
                    borderRadius: 1,
                    cursor: "pointer",
                    transition: "0.2s",
                    color: "#0a1a3b",
                    "&:hover": { 
                      color: "#00b0f0",
                      // backgroundColor: "#f8f8f8",
                      // transform: 'translateX(4px)'
                    },
                  }}
                  onClick={() => onNavigate(item)}
                >
                  {item.cardTitle}
                </Typography>
              )}
            </Box>
          );
        })
      ) : (
        <Typography color="text.secondary" fontSize={14}>No archives found.</Typography>
      )}
    </Paper>
  );
}